export function AddOns(){
  return (
    <table style={{ marginLeft: 'auto', marginRight: 'auto', fontSize: '22px'}}>
      <tbody>
        <tr>
          <td>30 min stretch</td>
          <td>+$50</td>
        </tr>
        <tr>
          <td>CBD Treatment</td>
          <td>+$25</td>
        </tr>
      </tbody>
    </table>
  )
}